// src/Features/HotelList/HotelSearchBar.jsx
import React, { useRef, useEffect, useState } from "react";
import { Row, Col, Button, Spinner } from "react-bootstrap";
import { FaMapMarkerAlt, FaCalendarAlt, FaUser, FaFlag } from "react-icons/fa";
import { TravelerSelector } from "../../../../components";
import { FaCity } from "react-icons/fa6";
import { Calendar } from "primereact/calendar";
import "./FlightSearchBar.css";
import { useTranslation } from "../../../../contexts/TranslationContext";
import Cookies from "js-cookie";
import { axiosGet } from "../../../../utils/apis/api";




export default function FlightSearchBar({ value, onChange, onDiscover, travelers, onTravelersChange  }) {

  const Lang = Cookies.get("preferred_language") || "en";
  const { t } = useTranslation();
  const destRef = useRef(null);
  const calRef = useRef(null);
  const depRef = useRef(null);

  // --- Destination autocomplete state ---
  const [term, setTerm] = useState(value.destination || "");
  const [openList, setOpenList] = useState(false);
  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState([]); // [{type: 'city'|'country', label, sublabel, location_docname, raw}]
  const [activeIdx, setActiveIdx] = useState(0);
  const [picked, setPicked] = useState(null); // last picked item
  const [touched, setTouched] = useState(false); 
  const [showTravelers, setShowTravelers] = useState(false);

  // --- Calendar popover state ---
  const [showCal, setShowCal] = useState(false); 


const [departureTerm, setDepartureTerm] = useState(value.departure || "");
const [departureItems, setDepartureItems] = useState([]);
const [openDepartureList, setOpenDepartureList] = useState(false);
const [activeDepartureIdx, setActiveDepartureIdx] = useState(0);
const [departureTouched, setDepartureTouched] = useState(false);
const [departureLoading, setDepartureLoading] = useState(false);
  
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (calRef.current && !calRef.current.contains(e.target)) {
        setShowCal(false);
      }
    };
    if (showCal) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showCal]);

  const [numberOfMonths, setNumberOfMonths] = useState(2);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setNumberOfMonths(1);
      } else {
        setNumberOfMonths(2); 
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);
 
  // keep local input in sync with external value
  useEffect(() => {
    if (value.destination !== term) setTerm(value.destination || "");
  }, [value.destination]); // eslint-disable-line

  // simple debounce
  const debouncedTerm = useDebounce(term, 300);
  const debouncedDepartureTerm = useDebounce(departureTerm, 300);

  // fetch destination on type
// useEffect(() => {
//   let abort = false;
//   const q = (debouncedTerm || "").trim();

//   if (q.length < 2) {
//     setItems([]);
//     setOpenList(false);
//     setLoading(false);
//     return;
//   }

//   (async () => {
//     try {
//       setLoading(true);

//       const locUrl = new URL(
//         "https://viaggioerp.inter-netsys.com/api/method/alltimes.alltimes_travel.doctype.airport.airport.airport"
//       );
//       locUrl.searchParams.set("search", q);

//       const res = await fetch(locUrl.toString(), {
//         headers: { Accept: "application/json" },
//       });
//       const json = await res.json().catch(() => ({}));

//       const airports = (json?.result?.items || []).slice(0, 20).map((x) => ({
//         name: x.name,
//         type: "airport",
//         label: x.airport_name,
//         sublabel: x.country || "",
//         abbreviation: x.abbreviation,
//         raw: x,
//       }));

//       if (!abort) {
//         setItems(airports);
//         setActiveIdx(0);
//         setOpenList(touched && airports.length > 0);
//       }
//     } catch {
//       if (!abort) {
//         setItems([]);
//         setOpenList(false);
//       }
//     } finally {
//       if (!abort) setLoading(false);
//     }
//   })();

//   return () => {
//     abort = true;
//   };
// }, [debouncedTerm, touched]);


useEffect(() => {
  let abort = false;
  const q = (debouncedTerm || "").trim();

  if (q.length < 2) {
    setItems([]);
    setOpenList(false);
    setLoading(false);
    return;
  }

  (async () => {
    try {
      setLoading(true);
      const params = { search: q };
      const json = await axiosGet(
        "https://viaggioerp.inter-netsys.com/api/method/alltimes.alltimes_travel.doctype.airport.airport.airport",
        params
      );
      const airports = (json?.result?.items || [])
        .slice(0, 20)
        .map((x) => ({
          name: x.name,
          type: "airport",
          label: x.airport_name,
          sublabel: x.country || "",
          abbreviation: x.abbreviation,
          raw: x,
        }));

      if (!abort) {
        setItems(airports);
        setActiveIdx(0);
        setOpenList(touched && airports.length > 0);
      }
    } catch (error) {
      console.error("Error fetching airports:", error);
      if (!abort) {
        setItems([]);
        setOpenList(false);
      }
    } finally {
      if (!abort) setLoading(false);
    }
  })();

  return () => {
    abort = true;
  };
}, [debouncedTerm, touched]);



// useEffect(() => {
//   let abort = false;
//   const q = (debouncedDepartureTerm || "").trim();
//   if (q.length < 2) {
//     setDepartureItems([]);
//     setOpenDepartureList(false);
//     setDepartureLoading(false);
//     return;
//   }

//   (async () => {
//     try {
//       setDepartureLoading(true);
//       const locUrl = new URL(
//         "https://viaggioerp.inter-netsys.com/api/method/alltimes.alltimes_travel.doctype.airport.airport.airport"
//       );
//       locUrl.searchParams.set("search", q);
//       const res = await fetch(locUrl.toString(), { headers: { Accept: "application/json" } });
//       const json = await res.json().catch(() => ({}));

//       const airports = (json?.result?.items || []).slice(0, 20).map((x) => ({
//         name: x.name,
//         type: "airport",
//         label: x.airport_name,       
//         sublabel: x.country || "",   
//         abbreviation: x.abbreviation, 
//         raw: x,
//       }));

//       if (!abort) {
//         setDepartureItems(airports);
//         setActiveDepartureIdx(0);
//         setOpenDepartureList(departureTouched && airports.length > 0);
//       }
//     } catch {
//       if (!abort) {
//         setDepartureItems([]);
//         setOpenDepartureList(false);
//       }
//     } finally {
//       if (!abort) setDepartureLoading(false);
//     }
//   })();

//   return () => { abort = true; };
// }, [debouncedDepartureTerm, departureTouched]);

useEffect(() => {
  let abort = false;
  const q = (debouncedDepartureTerm || "").trim();

  if (q.length < 2) {
    setDepartureItems([]);
    setOpenDepartureList(false);
    setDepartureLoading(false);
    return;
  }

  (async () => {
    try {
      setDepartureLoading(true);

      // نمرر البراميترات مباشرة إلى axiosGet
      const params = { search: q };

      // نستخدم axiosGet بدل fetch
      const json = await axiosGet(
        "https://viaggioerp.inter-netsys.com/api/method/alltimes.alltimes_travel.doctype.airport.airport.airport",
        params
      );

      const airports = (json?.result?.items || [])
        .slice(0, 20)
        .map((x) => ({
          name: x.name,
          type: "airport",
          label: x.airport_name,
          sublabel: x.country || "",
          abbreviation: x.abbreviation,
          raw: x,
        }));

      if (!abort) {
        setDepartureItems(airports);
        setActiveDepartureIdx(0);
        setOpenDepartureList(departureTouched && airports.length > 0);
      }
    } catch (error) {
      console.error("Error fetching departure airports:", error);
      if (!abort) {
        setDepartureItems([]);
        setOpenDepartureList(false);
      }
    } finally {
      if (!abort) setDepartureLoading(false);
    }
  })();

  return () => {
    abort = true;
  };
}, [debouncedDepartureTerm, departureTouched]);

  // pick an item from autocomplete
  //  const pick = (item) => {
  //   setPicked(item);
  //   setTerm(item.label);
  //   setOpenList(false);
  //   setTouched(false);
    
  //   // Update the search bar state using the onChange prop (which is setSearchBarState)
  //   onChange(prev => ({
  //     ...prev,
  //     destination: item.label,
  //     destinationId: item.name,
  //     search_type: item.type,
  //     search_query: item.location_docname
  //   }));
  // };
  const pick = (item) => {
  setPicked(item);
  setTerm(`${item.abbreviation}`); 
  setOpenList(false);
  setTouched(false);

  onChange(prev => ({
    ...prev,
    destination: `${item.abbreviation}`, 
    destinationId: item.name,
    search_type: item.type,
    search_query: item.location_docname
  }));
};

  // keyboard nav in autocomplete
  const onKeyDown = (e) => {
    if (!openList || !items.length) return;
    if (e.key === "ArrowDown") {
      e.preventDefault();
      setActiveIdx((i) => (i + 1) % items.length);
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setActiveIdx((i) => (i - 1 + items.length) % items.length);
    } else if (e.key === "Enter") {
      e.preventDefault();
      pick(items[activeIdx]);
    } else if (e.key === "Escape") {
      setOpenList(false);
    }
  };

  // pick Departure airport
const pickDeparture = (item) => {
  setDepartureTerm(item.abbreviation); 
  setOpenDepartureList(false);
  setDepartureTouched(false);


  onChange((prev) => ({
    ...prev,
    departure: item.abbreviation,             
    departureCode: item.abbreviation,  
    departure_type: item.type,
    departure_query: item.raw.name,    
  }));
};


// keyboard navigation
const onDepartureKeyDown = (e) => {
  if (!openDepartureList || !departureItems.length) return;
  if (e.key === "ArrowDown") {
    e.preventDefault();
    setActiveDepartureIdx((i) => (i + 1) % departureItems.length);
  } else if (e.key === "ArrowUp") {
    e.preventDefault();
    setActiveDepartureIdx((i) => (i - 1 + departureItems.length) % departureItems.length);
  } else if (e.key === "Enter") {
    e.preventDefault();
    pickDeparture(departureItems[activeDepartureIdx]);
  } else if (e.key === "Escape") {
    setOpenDepartureList(false);
  }
};

  // --- Calendar helpers (avoid null getTime errors) ---
  const parseISO = (s) => (s ? new Date(`${s}T00:00:00`) : null);
  const toISO = (d) => {
    if (!d) return "";
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, "0");
    const dd = String(d.getDate()).padStart(2, "0");
    return `${y}-${m}-${dd}`;
  };

  const startD = parseISO(value.checkin);
  const endD = parseISO(value.checkout);
  // Calendar expects: null | [Date] | [Date, Date]
  const calendarValue =
    startD || endD ? (endD ? [startD, endD] : [startD]) : null;

  const today = new Date();
  const maxBookDate = new Date(
    today.getFullYear() + 1,
    today.getMonth(),
    today.getDate()
  );



  const handleDiscover = () => {
    onDiscover(); 
  };

  return (
    <div className="rounded-4 hotellisit-search-bar-container p-3 position-relative">
      <Row className="g-2 align-items-center">
        {/* Left side: inputs */}
        <Col md={10}>
          <Row className="g-2 align-items-center">
            {/* Departure */}
            <Col md={3} className="position-relative">
              <div
                className="search-box"
                onClick={() => depRef.current?.focus()}
                role="button"
                tabIndex={0}
              >
                <FaMapMarkerAlt className="hotellist-icon" />
                <div className="search-texts">
                  <div className="search-label">{t("Departure")}</div>
                  <input
                    ref={depRef}
                    type="text"
                    className="search-input"
                    placeholder={t("Departure")}
                    value={departureTerm}
                    onChange={(e) => {
                      const v = e.target.value;
                      setDepartureTerm(v);
                      setOpenDepartureList(
                        departureTouched && v.trim().length >= 2
                      );
                    }}
                    onFocus={() => {
                      setDepartureTouched(true);
                      setOpenDepartureList(
                        departureItems.length > 0 &&
                          departureTerm.trim().length >= 2
                      );
                    }}
                    onKeyDown={onDepartureKeyDown}
                    aria-label="Departure"
                    autoComplete="off"
                  />
                </div>
                {departureLoading && (
                  <Spinner animation="border" size="sm" className="ms-2" />
                )}
              </div>

              {openDepartureList && departureItems.length > 0 && (
                <div className="hotellist-autocomplete shadow-lg rounded-3">
                  {departureItems.map((it, idx) => (
                    <button
                      key={`${it.type}-${it.label}-${idx}`}
                      type="button"
                      className={`hotellist-autocomplete-item ${
                        idx === activeDepartureIdx ? "active" : ""
                      }`}
                      onMouseDown={(e) => {
                        e.preventDefault();
                        pickDeparture(it);
                      }}
                    >
                      <span className="texts">
                        <span className="title">
                          {it.label} ({it.abbreviation})
                        </span>
                        <span className="subtitle">{it.sublabel}</span>
                      </span>
                    </button>
                  ))}
                </div>
              )}
            </Col>

            {/* Destination */}
            <Col md={3} className="position-relative">
              <div
                className="search-box"
                onClick={() => destRef.current?.focus()}
                role="button"
                tabIndex={0}
              >
                <FaMapMarkerAlt className="hotellist-icon" />
                <div className="search-texts">
                  <div className="search-label">{t("Destination")}</div>

                  <input
                    ref={destRef}
                    type="text"
                    className="search-input"
                    placeholder={t("Destination")}
                    value={term}
                    onChange={(e) => {
                      const v = e.target.value;
                      setTerm(v);
                      setOpenList(touched && v.trim().length >= 2);
                    }}
                    onFocus={() => {
                      setTouched(true);
                      setOpenList(items.length > 0 && term.trim().length >= 2);
                    }}
                    onKeyDown={onKeyDown}
                    aria-label="Destination"
                    autoComplete="off"
                  />
                </div>
                {loading && (
                  <Spinner animation="border" size="sm" className="ms-2" />
                )}
              </div>

              {openList && items.length > 0 && (
                <div className="hotellist-autocomplete shadow-lg rounded-3">
                  {items.map((it, idx) => (
                    <button
                      key={`${it.type}-${it.label}-${idx}`}
                      type="button"
                      className={`hotellist-autocomplete-item ${
                        idx === activeIdx ? "active" : ""
                      }`}
                      onMouseDown={(e) => {
                        e.preventDefault(); // prevent blur before click
                        pick(it);
                      }}
                    >
                      <span className="icon">
                        {it.type === "city" ? <FaCity /> : <FaFlag />}
                      </span>
                      <span className="texts">
                        <span className="title">
                          {it.label} ({it.abbreviation})
                        </span>
                        {it.sublabel && (
                          <span className="subtitle">{it.sublabel}</span>
                        )}
                      </span>
                    </button>
                  ))}
                </div>
              )}
            </Col>

            {/* Leaving on Date */}
            <Col md={3} className="position-relative">
              <div
                className="search-box"
                role="button"
                tabIndex={0}
                onClick={() => {
                  setShowCal((s) => !s);
                  setShowTravelers(false);
                }}
              >
                <FaCalendarAlt className="hotellist-icon" />
                <div className="search-texts">
                  <div className="search-label">{t("LeavingOn")}</div>
                  <div className="search-value">
                    {value.leaving
                      ? `Leaving on ${value.leaving}`
                      : t("SelectDate")}
                  </div>
                </div>
              </div>

              {showCal && (
                <div
                  ref={calRef}
                  className="hotellist-calendar-popover shadow-lg rounded-3 p-2"
                >
                  <Calendar
                 locale={Lang === 'ar' ? 'ar' : 'en'}
                  dir={Lang === 'ar' ? 'rtl' : 'ltr'}
                    value={value.leaving ? new Date(value.leaving) : null}
                    onChange={(e) => {
                      const date = e && "value" in e ? e.value : null;

                      onChange((prev) => ({
                        ...prev,
                        leaving: toISO(date) || "",
                      }));

                      if (date) {
                        setShowCal(false);
                      }
                    }}
                    selectionMode="single"
                    numberOfMonths={1}
                    readOnlyInput
                    inline
                    minDate={today}
                    maxDate={maxBookDate}
                    dateFormat="mm/dd/yy"
                  />
                </div>
              )}
            </Col>

            {/* Travelers */}
            {/* <Col md={3}>
              <div
                role="button"
                tabIndex={0}
                onClick={() => {
                  setShowTravelers((s) => !s);
                  setShowCal(false);
                }}
              >
                <TravelerSelector
                  isFrom={"hotelList"}
                  rooms={travelers}
                  onRoomsChange={onTravelersChange}
                />
              </div>
            </Col> */}
            <Col md={3} className="traveler-selector-flights">
              <TravelerSelector
                adults={travelers.adults}
                children={travelers.children}
                childrenAges={travelers.childrenAges || []}
                infants={travelers.infants}
                onAdultsChange={(val) =>
                  onTravelersChange({ ...travelers, adults: val })
                }
                onChildrenChange={(val) =>
                  onTravelersChange((prev) => {
                    console.log("*************");
                    const newChildrenAges =
                      val > (prev.childrenAges?.length || 0)
                        ? [
                            ...(prev.childrenAges || []),
                            ...Array(
                              val - (prev.childrenAges?.length || 0)
                            ).fill(null),
                          ]
                        : (prev.childrenAges || []).slice(0, val);

                    console.log(
                      "Children changed:",
                      val,
                      "New ages array:",
                      newChildrenAges
                    );

                    return {
                      ...prev,
                      children: val,
                      childrenAges: newChildrenAges,
                    };
                  })
                }
                onChildrenAgesChange={(ages) =>
                  onTravelersChange((prev) => ({ ...prev, childrenAges: ages }))
                }
                onInfantsChange={(val) =>
                  onTravelersChange({ ...travelers, infants: val })
                }
              />
            </Col>
          </Row>
        </Col>

        {/* Right side: Discover button */}
        <Col md={2}>
          <Button
            className="w-100 hotellist-search-button"
            onClick={handleDiscover}
          >
            <div>
              <svg
                className="search-icon"
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M21.7099 20.29L17.9999 16.61C19.44 14.8144 20.1374 12.5353 19.9487 10.2413C19.76 7.9473 18.6996 5.81278 16.9854 4.27664C15.2713 2.7405 13.0337 1.91951 10.7328 1.98247C8.43194 2.04543 6.24263 2.98756 4.61505 4.61514C2.98747 6.24272 2.04534 8.43203 1.98237 10.7329C1.91941 13.0338 2.74041 15.2714 4.27655 16.9855C5.81269 18.6997 7.94721 19.7601 10.2412 19.9488C12.5352 20.1375 14.8143 19.4401 16.6099 18L20.2899 21.68C20.3829 21.7737 20.4935 21.8481 20.6153 21.8989C20.7372 21.9497 20.8679 21.9758 20.9999 21.9758C21.1319 21.9758 21.2626 21.9497 21.3845 21.8989C21.5063 21.8481 21.6169 21.7737 21.7099 21.68C21.8901 21.4935 21.9909 21.2443 21.9909 20.985C21.9909 20.7257 21.8901 20.4765 21.7099 20.29ZM10.9999 18C9.61544 18 8.26206 17.5895 7.11091 16.8203C5.95977 16.0511 5.06256 14.9579 4.53275 13.6788C4.00293 12.3997 3.86431 10.9922 4.13441 9.63436C4.4045 8.2765 5.07119 7.02922 6.05016 6.05025C7.02912 5.07128 8.27641 4.4046 9.63427 4.1345C10.9921 3.8644 12.3996 4.00303 13.6787 4.53284C14.9578 5.06265 16.051 5.95986 16.8202 7.111C17.5894 8.26215 17.9999 9.61553 17.9999 11C17.9999 12.8565 17.2624 14.637 15.9497 15.9497C14.6369 17.2625 12.8564 18 10.9999 18Z"
                  fill="white"
                />
              </svg>
            </div>
            <div>{t("Discover")}</div>
          </Button>
        </Col>
      </Row>
    </div>
  );
}

/* ---------- small debounce hook ---------- */
function useDebounce(value, delay = 300) {
  const [v, setV] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setV(value), delay);
    return () => clearTimeout(t);
  }, [value, delay]);
  return v;
}